import speakersService from '@/services/speakers'

export default {
  namespaced: true,

  state: {
    speakersTitle: '',
    speakersText: '',
    speakersList: [],
    currentSpeaker: {},
    showSpeakerModal: false,
  },

  mutations: {
    setSpeakersTitle(state, title) {
      state.speakersTitle = title
    },

    setSpeakersText(state, text) {
      state.speakersText = text
    },

    setSpeakersList(state, list) {
      state.speakersList = list
    },

    setCurrentSpeaker(state, speaker) {
      state.currentSpeaker = speaker
    },

    setShowSpeakerModal(state, status) {
      state.showSpeakerModal = status
    },
  },

  actions: {
    fetchSpeakersText({ commit }) {
      speakersService.getSpeakersText().then(res => {
        commit('setSpeakersTitle', res.title)
        commit('setSpeakersText', res.text)
      })
    },

    fetchSpeakersList({ commit }) {
      speakersService.getSpeakersList().then(res => {
        commit('setSpeakersList', res)
      })
    },

    fetchSpeakersListHome({ commit }) {
      speakersService.getSpeakersListHome().then(res => {
        commit('setSpeakersList', res)
      })
    },
  },
}
